import { render } from "./AccountView.vue?vue&type=template&id=7733026c&scoped=true"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"

import "./AccountView.vue?vue&type=style&index=0&id=7733026c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7733026c"

export default script